import parser from 'ua-parser-js';

export const isMobile = (userAgent) => {
  const ua = parser(userAgent);
  return ua.device.type === 'mobile';
};
